import React from 'react';

import "./noNewAccountError.scss";

import { EmptyState } from 'commonsComponents/emptyState';
import { OKButton } from 'components/commons/OKButton/OKButton';
import { i18n } from 'core/i18n';
const { formatText } = i18n;

import { MYPROFILE_GLOBAL_URL } from 'constants/index';

function NoNewAccountError({ history }) {
    const title = formatText('contractsView-contractsView_savingsAccountGoToTransferErrorTitle');
    const message = formatText('contractsView-contractsView_savingsAccountGoToTransferErrorMessage');

    const backToGlobalPositionButton = (
        <OKButton
            onClick={() => history.push(MYPROFILE_GLOBAL_URL)}
        >
            {formatText('contractsView-backButtonLabelGlobal')}
        </OKButton>
    );
    return (
        <div className="no-new-account-error col-xs-12">
            <EmptyState
                button={backToGlobalPositionButton}
                primaryText={title}
                secondaryText={message}
                iconType="noitems-banking"
            />
        </div>);
}

export default NoNewAccountError;